import { useLazyQuery, useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import toast from "../../../components/toast";
import {
  CREATE_SIDEMENU,
  GET_ALLSIDEMENU,
  GET_SIDEMENU,
  UPDATE_SIDEMENU,
  GET_SCREENS_MAPPED_UNMAPPED_BY_ORGID,
  GET_DEPTS_BY_ORGID,
  GET_ORG_ROLES,
} from "../../../core/services/mutations";
import { useErrorsLog } from "../../ErrorsLog/useerrorsLog";

const useScreenConfig = ({ screenName, department, role, orgId }) => {
  const { t } = useTranslation("translations");
  const user = useSelector((state) => state.user.userData);
  const { createErrorLog } = useErrorsLog();
  const [getSideMenu, { loading: sideMenuLoad, data: sideMenuData }] =
    useLazyQuery(GET_SIDEMENU, {
      fetchPolicy: "network-only",
      refetchQueries: [
        {
          query: GET_DEPTS_BY_ORGID,
          variables: { orgId: orgId },
        },
        {
          query: GET_ORG_ROLES,
          variables: { orgId: orgId },
        },
      ],
      onError: (error) => {
        toast.error(`${t("ERROR")}`);
        createErrorLog(
          error,
          "getallSideMenu",
          user.userId,
          user.orgId,
          screenName.screenName
        );
      },
    });
  const [getallSideMenu, { data: allsideMenuData }] = useLazyQuery(
    GET_ALLSIDEMENU,
    {
      onError: (error) => {
        toast.error(`${t("ERROR")}`);
        createErrorLog(
          error,
          "getallSideMenu",
          user.userId,
          user.orgId,
          screenName.screenName
        );
      },
    }
  );

  const [createSideMenu] = useMutation(CREATE_SIDEMENU, {
    fetchPolicy: "network-only",
    refetchQueries: [
      {
        query: GET_DEPTS_BY_ORGID,
        variables: { orgId: orgId },
      },
      {
        query: GET_SCREENS_MAPPED_UNMAPPED_BY_ORGID,
        variables: { orgId: orgId },
      },
      {
        query: GET_ALLSIDEMENU,
        variables: { orgId: orgId },
      },
      {
        query: GET_SIDEMENU,
        variables: {
          department: department,
          role: role,
          orgId: orgId,
        },
      }, // DocumentNode object parsed with gql
    ],
    onCompleted: (res) => {
      toast.success(`${t("Success! Your screen configuration is complete.")}`);
    },
    onError: (error) => {
      toast.error(`${t("ERROR")}`);
      createErrorLog(
        error,
        "createSideMenu",
        user.userId,
        user.orgId,
        screenName.screenName
      );
    },
  });

  const [updateSideMenu] = useMutation(UPDATE_SIDEMENU, {
    fetchPolicy: "network-only",
    refetchQueries: [
      {
        query: GET_SCREENS_MAPPED_UNMAPPED_BY_ORGID,
        variables: { orgId: orgId },
      },
      {
        query: GET_SIDEMENU,
        variables: {
          department: department,
          role: role,
          orgId: orgId,
        },
      }, // DocumentNode object parsed with gql
    ],
    onCompleted: (res) => {
      toast.success(`${t("Success! Your screen configuration is updated.")}`);
    },
    onError: (error) => {
      toast.error(`${t("ERROR")}`);
      createErrorLog(
        error,
        "updateSideMenu",
        user.userId,
        user.orgId,
        screenName.screenName
      );
    },
  });
  return {
    loading: sideMenuLoad,
    createSideMenu,
    getSideMenu,
    sideMenuData,
    updateSideMenu,
    getallSideMenu,
    allsideMenuData,
  };
};

export default useScreenConfig;
